module.exports = __webpack_public_path__ + "static/media/15_APOTHEO_LABO_DODIE.2cf58e02.png";